import { get, deleteRequest, post, put } from './api'
import { GLOBALS } from '../utils/Globals'
import { getServerInfo } from '../utils/helpers/networkInfo.helper'

const serverUrl = getServerInfo('api')

export class VirtualMachineService {
  static async getAll(token, query = {}) {
    const data = await get(`${serverUrl}virtualmachines`, token, query)
    return VirtualMachineService.mapData(data)
  }

  static async virtualmachinesxemptypod(token, query = {}) {
    const data = await get(`${serverUrl}virtualmachinesxemptypod`, token, query)
    return VirtualMachineService.mapData(data)
  }

  static async virtualmachinesxpod(pod_id, token = {}) {
    const data = await get(`${serverUrl}virtualmachinesxpod/${pod_id}`, token)
    return VirtualMachineService.mapData(data)
  }

  static async getById(id, token) {
    const item = await get(`${serverUrl}virtualmachines/${id}`, token)
    return VirtualMachineService.mapItem(item)
  }

  static async create(data, token) {
    const item = await post(`${serverUrl}virtualmachines`, data, true, token)
    return VirtualMachineService.mapItem(item)
  }

  static bulkDelete(ids, token) {
    return deleteRequest(`${serverUrl}virtualmachines`, { ids }, true, token)
  }

  static delete(id, token) {
    return deleteRequest(`${serverUrl}virtualmachines/${id}`, null, false, token)
  }

  static async update(id, data, token) {
    const item = await put(`${serverUrl}virtualmachines/${id}`, data, true, token)
    return VirtualMachineService.mapItem(item)
  }

  static async powerOn(vm_name, token) {
    const data = { vm_name }
    return post(`${serverUrl}vm-power-on`, data, true, token)
  }

  static async powerOff(vm_name, token) {
    const data = { vm_name }
    return post(`${serverUrl}vm-power-off`, data, true, token)
  }

  static async reset(vm_name, token) {
    const data = { vm_name }
    return post(`${serverUrl}vm-reset`, data, true, token)
  }

  static async suspend(vm_name, token) {
    const data = { vm_name }
    return post(`${serverUrl}vm-suspend`, data, true, token)
  }

  static async createSnapshot(vm_name, snapshot_name, description, token) {
    const data = { vm_name, snapshot_name, description }
    return post(`${serverUrl}vm-snapshot/create`, data, true, token)
  }

  static async deleteSnapshot(vm_name, snapshot_name, token) {
    const data = { vm_name, snapshot_name }
    return post(`${serverUrl}vm-snapshot/delete`, data, true, token)
  }

  static async revertSnapshot(vm_name, snapshot_name, token) {
    const data = { vm_name, snapshot_name }
    return post(`${serverUrl}vm-snapshot/revert`, data, true, token)
  }

  static async listSnapshots(vm_name, token) {
    return get(`${serverUrl}vm-snapshot/${vm_name}`, token)
  }

  static async getFirstSnapshot(vm_name, token) {
    try {
      const response = await get(`${serverUrl}vm-snapshot/${vm_name}`, token)
      if (response && response.snapshots && response.snapshots.length > 0) {
        return response.snapshots[0] // Devuelve solo el primer snapshot
      }
      return null // Si no hay snapshots, devuelve null
    } catch (error) {
      console.error('Error fetching snapshots:', error.message)
      throw error
    }
  }

  static async listAllVMs(token) {
    return get(`${serverUrl}vm-list-all`, token)
  }

  static async getVMDetails(vm_name, token) {
    return get(`${serverUrl}vm-detail/${vm_name}`, token)
  }

  static async getVMsInFolder(token) {
    return get(`${serverUrl}vm-folder`, token)
  }

  static mapData(data) {
    return data.map((d) => VirtualMachineService.mapItem(d))
  }

  static mapItem(item) {
    item.type = GLOBALS.virtual_machine.types[item.type] || null
    return item
  }
}
